import { frontendURL } from '../../../helper/URLHelper';
import { isRevenueAutopilotEnabledForAccount } from '../../../helper/revenueAutopilotAccess';

const RevenueAutopilot = () => import('./RevenueAutopilot.vue');

export const ensureRevenueAutopilotAccess = (to, from, next) => {
  if (isRevenueAutopilotEnabledForAccount(to.params.accountId)) {
    return next();
  }
  return next(frontendURL(''));
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/revenue-autopilot'),
      name: 'revenue_autopilot',
      component: RevenueAutopilot,
      beforeEnter: ensureRevenueAutopilotAccess,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
